import { render, staticRenderFns } from "./DeviceBack.vue?vue&type=template&id=dad63174&"
import script from "./DeviceBack.vue?vue&type=script&lang=js&"
export * from "./DeviceBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports